import * as React from 'react';

const FallBackModule = () => {
  return <></>;
};

const V3TestModule = () => {
  return <><h1>Test</h1></>;
};

export { FallBackModule, V3TestModule };